import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AusenciasService } from './ausencias/services/ausencias.service';
import { AbsenceInfo } from './ausencias/models/absence-info.interface';
import { SnackBarService } from '../shared/services/snack-bar.service';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  absenceInfo: AbsenceInfo = JSON.parse(sessionStorage.getItem('absenceInfo')!);
  loading = false;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ausenciasService: AusenciasService,
    private snackBarService: SnackBarService
  ) {}

  ngOnInit(): void {
    if (sessionStorage.getItem('token') === null) {
      this.route.queryParams.subscribe((params) => {
        const token = params['token'];
        const absenceType = params['issueType'];
        const isRRHH = params['isRRHH'];
        if (token) {
          sessionStorage.setItem('token', token);
          sessionStorage.setItem('absenceType', absenceType);
          sessionStorage.setItem('isRRHH', isRRHH);
          this.getAbsenceInfo(token, absenceType);
        }
      });
    } else {
      const token = sessionStorage.getItem('token')!;
      const absenceType = sessionStorage.getItem('absenceType')!;
      this.getAbsenceInfo(token, absenceType);
    }
  }

  getAbsenceInfo(tokenId: string, absenceType: string): void {
    sessionStorage.removeItem('absenceInfo');
    this.loading = true;
    if (absenceType === 'ABSENCE') { 
      this.ausenciasService
        .getAbsenceJustification(tokenId)
        .subscribe({
          next: ({ absenceIssue }) => {
            this.absenceInfo = absenceIssue;
            sessionStorage.setItem(
              'absenceInfo',
              JSON.stringify(this.absenceInfo)
            );
            this.redirectToForm(absenceType);
          },
          error: (error) => {
            if (error.status !== 404) {
              this.snackBarService.openSnackBar(
                'Ocurrió un error, intente más tarde'
              );
            }
          },
        })
        .add(() => {
          this.loading = false;
        });
    } else {
      this.ausenciasService
        .getAbsencePreAdvice(tokenId)
        .subscribe({
          next: ({ preAdviceIssue }) => {
            this.absenceInfo = preAdviceIssue;
            sessionStorage.setItem(
              'absenceInfo',
              JSON.stringify(this.absenceInfo)
            );
            this.redirectToForm(absenceType);
          },
          error: (error) => {
            if (error.status !== 404) {
              this.snackBarService.openSnackBar(
                'Ocurrió un error, intente más tarde'
              );
            }
          },
        })
        .add(() => {
          this.loading = false;
        });
    }
  }

  redirectToForm(absenceType: string): void {
    if (absenceType === 'ABSENCE') {
      this.router.navigate(['/dashboard/ausencias/justificar']);
    } else {
      this.router.navigate(['/dashboard/ausencias/crear']);
    }
  }
}
